export const STOCK_TAKE_FIRST_GLANCE_COLUMN_KEYS = [
  'inStock',
  'parLevel',
  'UoM',
]

export const STOCK_TAKE_ENTRY_INPUT_COLUMN_KEYS = [
  ...STOCK_TAKE_FIRST_GLANCE_COLUMN_KEYS,
  'sold',
  'wastage',
]

export const STOCK_TAKE_TITLE_COLUMN_WIDTH = 240
export const STOCK_TAKE_TYPE_COLUMN_WIDTH = 110
export const STOCK_TAKE_SUPPLIER_COLUMN_WIDTH = 180
export const STOCK_TAKE_IN_STOCK_COLUMN_WIDTH = 140
export const STOCK_TAKE_PAR_COLUMN_WIDTH = 120
export const STOCK_TAKE_UOM_COLUMN_WIDTH = 220
export const STOCK_TAKE_SOLD_COLUMN_WIDTH = 140
export const STOCK_TAKE_WASTAGE_COLUMN_WIDTH = 220

export const STOCK_TAKE_COUNT_TABLE_SCROLL_X = 2200

export const STOCK_TAKE_COUNT_MODE_COLUMN_KEYS = [
  'title',
  'inStock',
  'parLevel',
  'UoM',
]

export const STOCK_TAKE_COUNT_MODE_SCROLL_X =
  STOCK_TAKE_TITLE_COLUMN_WIDTH +
  STOCK_TAKE_IN_STOCK_COLUMN_WIDTH +
  STOCK_TAKE_PAR_COLUMN_WIDTH +
  STOCK_TAKE_UOM_COLUMN_WIDTH

export const parseStockTakeColumnWidth = width => {
  if (typeof width === 'number' && Number.isFinite(width)) return width
  if (typeof width === 'string' && width.endsWith('px')) {
    const parsed = Number.parseInt(width, 10)
    return Number.isFinite(parsed) ? parsed : 0
  }
  return 0
}

/** Min-width for the one table in count-only and sold/wastage. */
export const sumStockTakeColumnScrollX = (columns = []) => {
  const sum = (Array.isArray(columns) ? columns : []).reduce(
    (total, column) => total + parseStockTakeColumnWidth(column?.width),
    0,
  )
  return Math.max(sum, STOCK_TAKE_COUNT_MODE_SCROLL_X)
}

export const shouldDefaultStockTakeCountMode = stockTake => {
  if (String(stockTake?.countType || 'MAIN').toUpperCase() === 'PARTIAL') {
    return true
  }
  const supplierIds = Array.isArray(stockTake?.supplierIds)
    ? stockTake.supplierIds
    : []
  return supplierIds.filter(Boolean).length > 0
}

export const filterStockTakeCountModeColumns = (columns = [], countMode) => {
  if (!countMode) return columns
  const allowed = new Set(STOCK_TAKE_COUNT_MODE_COLUMN_KEYS)
  return columns.filter(column => allowed.has(column.key))
}

/** Lime Manage-conversions control: count mode hides it; Sold & wastage keeps it. */
export const shouldShowStockTakeConversionPencil = ({
  countMode = false,
  isLocked = false,
  isRecipe = false,
  isLinkedStockGroup = false,
} = {}) => {
  if (countMode || isLocked || isRecipe || isLinkedStockGroup) return false
  return true
}

/** Count mode shows pack as text. The conversion dropdown lives under Sold & wastage. */
export const shouldShowStockTakeConversionSelect = ({
  countMode = false,
} = {}) => !countMode

export const STOCK_TAKE_TABLE_COLUMN_KEY_ORDER = [
  'title',
  ...STOCK_TAKE_ENTRY_INPUT_COLUMN_KEYS,
  'size',
  'type',
  'supplier',
  'linkedActions',
  'price',
  'sku',
  'lastQuantity',
  'qtySinceLastStockTake',
  'expectedQty',
  'stockAmount',
  'wastageAmount',
  'variance',
  'weighted',
  'total_vat',
  'total_net',
  'total_price',
]

export const areEntryInputColumnsAfterTitle = (columnKeys = []) => {
  const titleIndex = columnKeys.indexOf('title')
  if (titleIndex === -1) return false

  return STOCK_TAKE_FIRST_GLANCE_COLUMN_KEYS.every(
    (key, offset) => columnKeys[titleIndex + 1 + offset] === key,
  )
}

export const reorderStockTakeTableColumns = (columns = []) => {
  const rank = new Map(
    STOCK_TAKE_TABLE_COLUMN_KEY_ORDER.map((key, index) => [key, index]),
  )

  return [...columns].sort((left, right) => {
    const leftRank = rank.has(left.key)
      ? rank.get(left.key)
      : Number.MAX_SAFE_INTEGER
    const rightRank = rank.has(right.key)
      ? rank.get(right.key)
      : Number.MAX_SAFE_INTEGER

    if (leftRank !== rightRank) return leftRank - rightRank
    return 0
  })
}
